<template>
    <div class="w-full p-4 bg-[#F0F0F0] column_start_start">
        <div class="row_center_start w-full flex-wrap mb-2">
            <text class="font-base font-semibold text-[#666666] mr-3">預約自取日期</text>
            <text class="font-base">{{ deliveryDate }}</text>
        </div>
        <div class="row_center_start w-full flex-wrap">
            <text class="font-base font-semibold text-[#666666] mr-3">預約自取時間</text>
            <text class="font-base">{{ deliveryTime }}</text>
        </div>
        <div class="w-full h-1 border-b border-dashed border-[#000] my-4"></div>
        <div class="column_start_start w-full flex-wrap">
            <text class="font-base font-semibold text-[#666666] mb-2">店家訊息</text>
            <!-- TODO: 店家訊息 -->
            <text class="font-base">取餐時，請提供自取號碼。</text>
            <text class="font-base">付款後，依現場排序，完成取餐。</text>
        </div>
    </div>
</template>
<script>
export default {
    computed: {
        geturlParameters() {
            return this.$route.params
        },
        getPayment() {
            return this.$store.state.cart.payment
        },
        deliveryDate() {
            return this.getPayment.pickupDate
        },
        deliveryTime() {
            return this.getPayment.pickupTime
        },
        deliveryAddress() {
            return this.getPayment.address
        },
        deliveryPhone() {
            return this.getPayment.phone
        }
    }
}
</script>
<style lang="">

</style>